var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4996 8.95C22.4246 8.9375 22.3371 8.9375 22.2621 8.95C20.5371 8.8875 19.1621 7.475 19.1621 5.725C19.1621 3.9375 20.5996 2.5 22.3871 2.5C24.1746 2.5 25.6121 3.95 25.6121 5.725C25.5996 7.475 24.2246 8.8875 22.4996 8.95Z",
    stroke: "#E47100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2113 18.0502C22.9238 18.3377 24.8113 18.0377 26.1363 17.1502C27.8988 15.9752 27.8988 14.0502 26.1363 12.8752C24.7988 11.9877 22.8863 11.6877 21.1738 11.9877",
    stroke: "#E47100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46406 8.95C7.53906 8.9375 7.62656 8.9375 7.70156 8.95C9.42656 8.8875 10.8016 7.475 10.8016 5.725C10.8016 3.9375 9.36406 2.5 7.57656 2.5C5.78906 2.5 4.35156 3.95 4.35156 5.725C4.36406 7.475 5.73906 8.8875 7.46406 8.95Z",
    stroke: "#E47100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75078 18.0502C7.03828 18.3377 5.15078 18.0377 3.82578 17.1502C2.06328 15.9752 2.06328 14.0502 3.82578 12.8752C5.16328 11.9877 7.07578 11.6877 8.78828 11.9877",
    stroke: "#E47100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 18.2879C14.9246 18.2754 14.8371 18.2754 14.7621 18.2879C13.0371 18.2254 11.6621 16.8129 11.6621 15.0629C11.6621 13.2754 13.0996 11.8379 14.8871 11.8379C16.6746 11.8379 18.1121 13.2879 18.1121 15.0629C18.0996 16.8129 16.7246 18.2379 14.9996 18.2879Z",
    stroke: "#E47100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3629 22.2252C9.60039 23.4002 9.60039 25.3252 11.3629 26.5002C13.3629 27.8377 16.6379 27.8377 18.6379 26.5002C20.4004 25.3252 20.4004 23.4002 18.6379 22.2252C16.6504 20.9002 13.3629 20.9002 11.3629 22.2252Z",
    stroke: "#E47100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.0689ca336e2e9310455d0bcbdb88ee08.svg";
export { ForwardRef as ReactComponent };